<template>
  <div class="toast-position">
    <div class="toast-container">
      <transition-group name="toastDown">
        <div class="toast" :class="[msg.type]" v-for="(msg, index) in messages" :key="index + 0">
          <div class="option">
            <i class="fa fa-times" aria-hidden="true" @click="e => deleteToastAction(index)"></i>
          </div>
          <div class="content-block row-block">
            <img :src="{
              success: require('../../assets/images/toast-alert-icon.svg'),
              error: require('../../assets/images/toast-error-icon.svg')
            }[msg.type]">
            <div :style="{ width: '20px' }"></div>
            <div :style="{ flex: 1 }" class="content" :class="[msg.type]" v-html="msg.content"></div>
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: mapGetters([
    'messages'
  ]),
  methods: {
    ...mapActions([
      'deleteToastAction'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tool/toast.vue